import { copyTextToClipboard } from "../../../../utils/actions/clipboard";
import { toastSuccess } from "../../../../utils/toasts";
import { ROUTES } from "../../../../routes";

export const copyLink = (
  e: React.MouseEvent<HTMLButtonElement>,
  public_id: string
) => {
  e.preventDefault();
  if (public_id) {
    const href = ROUTES.INVOICE_BUSSINES_VIEW.replace(":id", public_id);
    copyTextToClipboard(window.location.origin + href);
    toastSuccess("Link copied!");
  }
};
